import { useDispatch } from "react-redux"
import { Modal, Button, Alert } from "components/common"
import { toast } from "react-toastify"
import { recordLead } from "redux/crm/leadSlice"
import { FaRecordVinyl } from "react-icons/fa"
import React from 'react';
import PropTypes from 'prop-types';

const LeadRecordConfirm = ({showModal, setshowModal, lead }) => {
  const leadId = lead.id

  const dispatch = useDispatch()

  const closeModal = () => {
    setshowModal(false)
  }

  const handleCancel = () => {
    closeModal()
  }

  const handleSubmit = (e) => {
    e.preventDefault()

    try {
      dispatch(recordLead(leadId))
      closeModal()
    }
    catch(error) {
      toast.error(error.message)
    }
  }

  return (
    <Modal
      show={showModal}
      onHide={closeModal}
      title="Record confirmation!"
      backdropClick={false}
      footer={(
        <>
          <Button size="sm" type="submit" variant="primary" form="lead-record-confirm-form">
            <FaRecordVinyl className="tw-text-red-600"/> Record
          </Button>
          <Button size="sm" variant="danger" onClick={handleCancel}>Cancel</Button>
        </>
      )}
    >
      <form id="lead-record-confirm-form" onSubmit={handleSubmit}>
        <Alert type="warning">
          Are you sure record Lead ID#{lead.id} keep in database?
        </Alert>
      </form>
    </Modal>
  )
};

LeadRecordConfirm.propTypes = {
  showModal: PropTypes.bool.isRequired,
  setshowModal: PropTypes.func.isRequired,
  lead: PropTypes.object.isRequired
}

export default LeadRecordConfirm;
